/**
* directive.recovery Module
*
* Description
*/
var app = angular.module('directives.recovery', []);

    require('./directives/passwordrecovery.directive.js');
    require('./stylesheet/style.scss');

module.exports = app;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/passwordRecovery/index.js
 ** module id = 192
 ** module chunks = 1
 **/